module.exports = __webpack_public_path__ + "static/fonts/Mont-RegularItalic.46f5a51.ttf";